import { DateTime, Duration } from "luxon";
import { JobDetailsService } from "./job-details-service";
import { LocationUpdates } from "./location-update";
import { ClosedDay, OpeningHour, ProductDetails, SelectedProduct } from "./private-location";

export class Location {
  id?: string;
  activityName?:string;
  locationId?: string;
  locationName?: string;
  template?:string;
  latitude?: number;
  longitude?: number;
  address?: string;
  postalCode?: string;
  city?: string;
  country?: string;
  countryCode?:string;
  stopTime?: Duration;
  serviceFromTime?: Duration;
  serviceTime?: Duration;
  serviceToTime?:Duration; 
  pickupCapacityType1?: number;
  pickupCapacityType2?: number;
  pickupCapacityType3?: number;
  deliveryCapacityType1?: number;
  deliveryCapacityType2?: number;
  deliveryCapacityType3?: number;
  precedence?: number;
  qualifications?: string;
  stopNumber?: number;
  sequenceNumber?: number;
  jobNumber?: string;
  planName?: string;
  planId?: string;
  jobId?: string;
  closedDay?: string;
  arrivalTime?: DateTime;
  departureTime?:DateTime;
  customData?: string;
  locationAdditionalInfo?: string;
  productAdditionalInfo?: string;
  servicesCount?: number;
  createdAt!: DateTime;
  priority?: number;
  isScheduled?: boolean;
  services?: JobDetailsService[];
  isEndTerminal? : boolean;
  isStartTerminal? : boolean;
  openHours?:string;
  segment?:string;
  productId?: string;
  prodId?: string;
  productName?: string;
  tenantLocationId?: string;
  isChecked? : boolean;
  day?: number;
  locationUpdates? : LocationUpdates[];
  hasUpdate? : boolean;
  distributionLaneId? : string | undefined;
  openingHours?: OpeningHour[]
  closedDays?: ClosedDay[]
  selectedProducts?: SelectedProduct[]
  products?: ProductDetails[]
  shouldVisitIfNoService?: boolean
}
